export const products = [
  {
    id: 1,
    img: "/static/img/crypto.jpeg",
    link: "https://cryptomoniter.netlify.app/",
  },
  {
    id: 2,
    img: "/static/img/fame.jpg",
    link: "https://fameclix.netlify.app/",
  },

  {
    id: 3,
    img: "/static/img/TaxGlobal.png",
    link: "https://taxglobal.netlify.app/",
  },
  {
    id: 4,
    img: "/static/img/blog.png",
    link: "https://yourstory.netlify.app/",
  },
  {
    id: 5,
    img: "/static/img/clubhouse.png",
    link: "https://talkhouse.netlify.app/",
  },
  {
    id: 6,
    img: "/static/img/admin.png",
    link: "https://adminumesh.netlify.app/",
  },
];

export const Skill = [
  {
    src: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png",
    text: "  HTML is the standard markup language for documents designed to be displayed in a web browser.",
  },
  {
    src: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png",
    text: " CSS is the language we use to style an HTML document.",
  },
  {
    src: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png",
    text: "  JavaScript is the world's most popular programming language.",
  },
  {
    src: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png",
    text: "  React is a JavaScript library for building user interfaces",
  },
  {
    src: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/visual-studio-code/visual-studio-code.png",
    text: "  I develop full-blown web apps using HTML, CSS and JavaScript MERN Stack with VS Code.",
  },
];

export const Events = [
  {
    date: "Oct 2023-Present",
    event:
      'Johnson Control (Mindteck) - Senior SDE Frontend',
  },
  {
    date: "Aug 2022-Oct 2023",
    event:
      'PristynCare x Lybrate  - Frontend Engineer ',
  },
  {
    date: "Apr 2021-Aug 2022",
    event:
      'Zingbus - Software Development Engineer \'<a href="https://www.zingbus.com/">InterCity Bus Services Company across India</a>',
  },
  {
    date: "Jul 2018 -June 2020",
    event: "CSC e-governance Services India - Operational Engineer- Supervisor",
  },
];
